import React from "react"
import { motion } from "framer-motion"
import { useColors } from "@mallardbay/lib-react-components"

import { componentStylesCss } from "~utils/helpers/style-helpers"

const DOT_SIZE_PX = 6
const DOT_BOUNCE_PX = -3
const DOT_CYCLE_DURATION_S = 1.1
const DOT_STAGGER_S = 0.15
const DOT_MIN_OPACITY = 0.35

interface Props {
    readonly index: number
}

export default function AnimatedTypingDot({ index }: Props) {
    const styles = useStyles()

    return (
        <motion.span
            style={styles.dot}
            animate={{
                y: [0, DOT_BOUNCE_PX, 0],
                opacity: [DOT_MIN_OPACITY, 1, DOT_MIN_OPACITY],
            }}
            transition={{
                duration: DOT_CYCLE_DURATION_S,
                repeat: Infinity,
                ease: "easeInOut",
                delay: index * DOT_STAGGER_S,
            }}
        />
    )
}

function useStyles() {
    const colors = useColors()

    return componentStylesCss({
        dot: {
            display: "inline-block",
            width: DOT_SIZE_PX,
            height: DOT_SIZE_PX,
            borderRadius: "50%",
            backgroundColor: colors.secondaryText,
        },
    })
}
